// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_bu-b";
export var colorBlue = "_bu-8";
export var colorDot = "_bu-0";
export var colorDotLarge = "_bu-2";
export var colorDotSmall = "_bu-1";
export var colorGreen = "_bu-7";
export var colorGrey = "_bu-3";
export var colorOrange = "_bu-5";
export var colorPink = "_bu-a";
export var colorPurple = "_bu-9";
export var colorRed = "_bu-4";
export var colorYellow = "_bu-6";